module.exports = __webpack_public_path__ + "static/collectorcans-slide-img-1-de-DE-9dfd7d392cc8608942f75ba477820d23.png";